import * as Yup from 'yup';
import { States } from '../../../../../constants';
import { ReactSelectOption } from '../../../../../types/Constants';
import { zipCodeRegEx } from '../../../../../utils/RegularExpressions';

export const projectTypes: { id: string; label: string; name: string }[] = [
  {
    id: 'principalCompletedAffordable',
    name: 'affordable',
    label: 'Affordable',
  },
  {
    id: 'principalCompletedWorkForce',
    name: 'workForce',
    label: 'Work Force',
  },
  {
    id: 'principalCompletedMarketRate',
    name: 'marketRate',
    label: 'Market Rate',
  },
  {
    id: 'principalCompletedSenior',
    name: 'senior',
    label: 'Senior',
  },
  {
    id: 'principalCompletedMixedIncome',
    name: 'mixedIncome',
    label: 'Mixed Income',
  },
  {
    id: 'principalCompletedMixedUse',
    name: 'mixedUse',
    label: 'Mixed Use',
  },
  {
    id: 'principalCompletedCommercialProject',
    name: 'commercialProject',
    label: 'Commercial Project',
  },
];
export const constructionTypes: { id: string; label: string; name: string }[] =
  [
    {
      id: 'principalCompletedNewConstruction',
      name: 'newConstruction',
      label: 'New Construction',
    },
    {
      id: 'principalCompletedHistoricRenovation',
      name: 'historicRenovation',
      label: 'Historic Renovation',
    },
    {
      id: 'principalCompletedRenovation',
      name: 'renovation',
      label: 'Renovation',
    },
    {
      id: 'principalCompletedAdaptiveReuse',
      name: 'adaptiveReuse',
      label: 'Adaptive Reuse',
    },
    {
      id: 'principalCompletedInplaceRenovation',
      name: 'inPlaceRenovation',
      label: 'In-Place Renovation',
    },
  ];

const validStateOptions: ReactSelectOption[] = States.map((state) => ({
  label: state.name,
  value: state.name,
}));
const today = new Date();

export const validationSchema = Yup.object({
  companyName: Yup.string()
    .required('Company Name is required')
    .min(2, 'Company Name must be greater than 2 character.'),
  projectName: Yup.string()
    .required('Project Name is required')
    .min(2, 'Project Name must be greater than 2 character'),
  dateCompleted: Yup.date()
    .required('Date Completed is required')
    .typeError('Date is invalid')
    .max(today, 'Completed Data cannot be in future.'),
  streetAddress: Yup.string()
    .required('Street Address is required')
    .min(4, 'Street Address must be greater than 4 character'),
  city: Yup.string()
    .required('City is required')
    .min(2, 'City must be greater than 2 character'),
  state: Yup.string()
    .required('State is required')
    .transform((v) => v.value),
  zipCode: Yup.string()
    .required('Zip / Postal code is required')
    .matches(zipCodeRegEx, 'Zip / Postal Code must be a 5 digit number')
    .max(5, 'Zip / Postal Code must be 5 digits')
    .min(5, 'Zip / Postal Code must be 5 digits'),
  grossBuildingArea: Yup.number()
    .required('Gross Building Area is required')
    .typeError('Gross Building Area must be a number')
    .positive('Gross Building Area must be Number of Housing Units')
    .min(1, 'Gross Building Area must be greater than 1'),
  housingUnits: Yup.number()
    .typeError('Number of Housing Units must be a number')
    .positive('Number of Housing Units must be positive number')
    .min(1, 'Number of Housing Units must be greater than 1'),
  developmentCost: Yup.number()
    .required('Total Development Cost is required')
    .typeError('Total Development Cost must be a number')
    .positive('Total Development Cost must be greater than 0.')
    .integer('Total Development Cost must be whole number not in decimal.'),
  projectTypes: Yup.array()
    .of(Yup.string())
    .min(1, 'Project Type is required')
    .typeError('Project Type is required'),
  constructionTypes: Yup.array()
    .of(Yup.string())
    .min(1, 'Construction Type is required')
    .typeError('Construction Type is required'),
});

export const emptyPrincipalCompletedProject = {
  id: '',
  companyName: '',
  projectName: '',
  dateCompleted: '',
  streetAddress: '',
  city: '',
  state: '',
  zipCode: '',
  grossBuildingArea: '',
  housingUnits: '',
  developmentCost: '',
  projectTypes: [],
  constructionTypes: [],
};

export const emptyCompanyCompletedProject = {
  id: '',
  projectName: '',
  dateCompleted: '',
  streetAddress: '',
  city: '',
  state: '',
  zipCode: '',
  grossBuildingArea: '',
  housingUnits: '',
  developmentCost: '',
  projectTypes: [],
  constructionTypes: [],
  companyRole: [],
};
